import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const ObservacionesGeneralesFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='OBSERVACIONES' htmlFor='input-observacionesGenerales' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='observacionesGenerales'>
          {({ field }) => (
            <Form.InputText
              {...field}
              id='input-observacionesGenerales'
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(ObservacionesGeneralesFormGroup)
